// @import dependencies
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {ReferencesFormModuleLayout} from 'app_components/modules/admin/landings/referencesForm'
// @end

// @import events
// @end

// @import utils
import { ScreenNotificationsUtil } from 'app_utils/screenNotification'
import { I18nUtil } from 'app_utils/i18n'
// @end

// @import services
import PermissionService from 'app_services/secure/permission/permissionService'
import LandingService from 'app_services/admin/landings/landingService'
// @end

// @import types
import { IReferences, ILanding } from 'app_types/admin/landings/landingTypes'
// @end

// @ADD Component types
interface IReferencesFormModuleProps {
  landingInfo: ILanding | null
  data?: Array<IReferences>
  source: string
  onHandleSaved: (data: any) => void | null
}
interface IReferencesFormModuleState {
  loadingForm: null | 'loading'
}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class ReferencesFormModule extends Component<IReferencesFormModuleProps, IReferencesFormModuleState> {

  public moduleName: string = 'module:landings'
  private permission: PermissionService
  private landingService: LandingService
  private screenNotifications: ScreenNotificationsUtil
  private i18nUtil: I18nUtil

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IReferencesFormModuleProps) {
    super(props)
    this.state = {
      loadingForm: null
    }

    this.permission = new PermissionService(this.moduleName)
    this.landingService = new LandingService()
    this.screenNotifications = new ScreenNotificationsUtil()
    this.i18nUtil = new I18nUtil()
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {}

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods
  public handleDelete = async (unique: string) => {
    let confirm = this.screenNotifications.fire({
      message: `Esta acción no podrá revertirse`,
    },
    {
      type: 'warning',
      title: `¿Eliminar?`,
      confirmButtonText: `${this.i18nUtil.getTranslate('components.screen_notifications.buttons.confirmButtonText')}`,
      cancelButtonText: `${this.i18nUtil.getTranslate('components.screen_notifications.buttons.cancelButtonText')}`,
      showCancelButton: true,
    })

    if (confirm) {
      confirm.then(async (result) => {
        if (result.value) {
          this.setState({loadingForm: 'loading'})

          const remove = await this.landingService.removeReference(this.props.source, unique)

          this.setState({loadingForm: null})

          if (remove) {
            let screen_notification_label = 'components.screen_notifications.delete'

            this.screenNotifications.fireToast(
              {
                message: `${this.i18nUtil.getTranslate(screen_notification_label)}`,
              },
              {
                position: 'top',
              }
            )

            if(this.props.onHandleSaved !== null){
              this.props.onHandleSaved({status: 'success'})
            }
          }
        }
      })
    }
  }

  onHandleGeneralInfoSubmit = async (formData: any) => {
    this.setState({loadingForm: 'loading'})

    const landingResponse = await this.landingService.saveGeneralInfo(
      {...formData, slug: this.props.source},
      (this.props.landingInfo && this.props.landingInfo.landing?._id) ? `update/${this.props.landingInfo.landing._id}` : 'create'
    )

    this.setState({loadingForm: null})

    if (landingResponse) {
      let screen_notification_label = 'components.screen_notifications.update'

      this.screenNotifications.fireToast(
        {
          message: `${this.i18nUtil.getTranslate(screen_notification_label)}`,
        },
        {
          position: 'top',
        }
      )

      if(this.props.onHandleSaved !== null){
        this.props.onHandleSaved({status: 'success'})
      }
    }
  }

  render() {
    return(
      <ReferencesFormModuleLayout
        {...this.props}
        handleDelete={this.handleDelete}
        landingInfo={this.props.landingInfo}
        loadingForm={this.state.loadingForm}
        onHandleGeneralInfoSubmit={this.onHandleGeneralInfoSubmit}
      />
    )
  }
}

export default connect(mapStatesToProps)(ReferencesFormModule)
